import { postJsonRequest } from '@chilecompra/react-kit'
import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { AFFIDAVIT_SIGN_SOURCE } from '../config/settings/constants'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Check if the seller is blacklisted.
 */
export const checkSellerIsBlacklisted = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/listanegra/${dni}`)
)

/**
 * Gets the seller data.
 */
export const getSeller = factoryService(({ dni = '' }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/${dni}`)
)

/**
 * Gets the seller activities data.
 */
export const getSellerActivities = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/actividad-economica/${dni}`, { retries: 2 })
)

/**
 * Gets the seller address.
 */
export const getSellerAddress = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/direcciones/${dni}`)
)

/**
 * Gets the seller business data.
 */
export const getSellerBusiness = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/contribuyente/${dni}`, { retries: 2 })
)

/**
 * Get the income bracket for a given 'natural' seller dni and year.
 */
export const getSellerIncomeBracket = factoryService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/tramo-renta/${dni}/${year}`)
)

/**
 * Get the sales income for a given 'legal' seller dni and year.
 */
export const getSellerIncomeSales = factoryService(({ dni, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/tramo-venta/${dni}/${year}`)
)

/**
 * Gets the seller type data.
 */
export const getSellerType = factoryService(({ dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/esJuridico/${dni}`)
)

/**
 * Create the seller affidavit.
 */
export const signAffidavit = factoryService(
  ({
    accessToken,
    boardMembers,
    businessDNI,
    businessName,
    haveRelatedCompanies,
    isNational,
    language,
    signType,
    sii,
    taxPayer,
    token
  }) => {
    const body = {
      declaracion: {
        tipoFirma: signType,
        tieneEmpresaRelacionada: haveRelatedCompanies,
        empresa: {
          esDesdeSII: sii,
          razonSocial: businessName,
          esNacional: isNational,
          tipoContribuyenteCod: taxPayer.id,
          tipoContribuyenteDesc: taxPayer.name
        },
        personas: boardMembers,
        tipoIdioma: language === 'es' ? 1 : 2
      },
      lugarFirma: AFFIDAVIT_SIGN_SOURCE,
      rut: businessDNI,
      tokenReCaptcha: token
    }
    const customHeaders = accessToken ? { ClaveUnicaToken: accessToken } : {}

    return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/beneficiarios-finales-registro/firmada`, {
      body,
      customHeaders
    })
  }
)

/**
 * Get the information for the seller if is blocked.
 */
export const postBlockedInformation = factoryService(({ dni, isForeign, isLog, module }) => {
  const body = { isForeign, isLog, modulo: module, rut: dni }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/bloqueado`, { body })
})
